class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.openTime = 0;

    this.throttle = (func, delay) => {
      let lastCall = 0;
      return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
          return;
        }
        lastCall = now;
        return func(...args);
      };
    };


    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    
    this.summaryToggle.addEventListener(
      'click',
      this.throttle(this.onSummaryClick.bind(this), 500)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.throttle(this.close.bind(this), 1000)
    );

    this.searchBox = this.querySelector('input:not([type="hidden"])');
    this.searchBox.addEventListener("input", this.onSearchBoxInput.bind(this));

    this.summaryToggle.setAttribute("role", "button");

    this.bottomSearchBoxValue;
  }

  onSearchBoxInput(event) {
    applyTopStyle(this, this.bottomSearchBoxValue, "[data-predictive-search]");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('modal-overlay')
    )
      this.close(false);
  }

  open(event) {
    this.openTime = Date.now();
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
    this.bottomSearchBoxValue = getBottomPosition(this, ".search-modal");
    applyTopStyle(this, this.bottomSearchBoxValue, "[data-predictive-search]");
  }

  close(focusToggle = true) {
    if (Date.now() - this.openTime < 500) {
      return;
    }
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define('details-modal', DetailsModal);


function adjustTopPosition(
  element,
  searchModalSelector,
  predictiveSearchHeaderSelector
) {
  const searchModal = element.querySelector(searchModalSelector);
  if (searchModal) {
    const rect = searchModal.getBoundingClientRect();
    const predictiveSearchHeaders = element.querySelectorAll(
      predictiveSearchHeaderSelector
    );
    predictiveSearchHeaders.forEach((predictiveSearchHeader) => {
      predictiveSearchHeader.style.top = `${rect.bottom}px`;
    });
  } else {
    console.warning("Search field not found");
  }
}

// Auxiliary functions

function getBottomPosition(element, searchModalSelector) {
  const searchModal = element.querySelector(searchModalSelector);
  if (searchModal) {
    const rect = searchModal.getBoundingClientRect();
    return rect.bottom;
  } 
}

function applyTopStyle(element, bottomValue, predictiveSearchHeaderSelector) {
  if (window.innerWidth > 749) {
    const predictiveSearchHeaders = element.querySelectorAll(
      predictiveSearchHeaderSelector
    );
    predictiveSearchHeaders.forEach((predictiveSearchHeader) => {
      predictiveSearchHeader.style.top = `${bottomValue}px`;
    });
  }
}
